<template>
  <b-modal
    id="civil-status-preview-modal"
    class="custom-modal"
    centered
    title="Preview"
    body-class="py-3"
    hide-footer
    no-close-on-backdrop
  >
    <b-form-group>
      <template slot="label">
        Civil Status <span class="text-danger">*</span>
      </template>
      <b-row>
        <b-col md="5" class="mb-3 mb-md-0">
          <b-form-select value="month">
            <option v-for="(civilStatusOption, index) in civilStatusOptions" :key="index" :value="civilStatusOption">{{ civilStatusOption }}</option>
          </b-form-select>
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
    name: "ParenthoodModal",
    computed: {
        civilStatusOptions() {
            const civilStatusOptions = [
                "Single",
                "Married",
                "Separated",
                "Widow/Widower"
            ];
            return civilStatusOptions;
        }
    }
};
</script>
